import { render, staticRenderFns } from "./CalendarioEventos.vue?vue&type=template&id=3dc0ec74&"
import script from "./CalendarioEventos.vue?vue&type=script&lang=js&"
export * from "./CalendarioEventos.vue?vue&type=script&lang=js&"
import style0 from "./CalendarioEventos.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports